// extracted by mini-css-extract-plugin
module.exports = {"modalBodyImageCropper":"styles_modalBodyImageCropper__1BZBE"};